module.exports = __webpack_public_path__ + "img/Very Left Screenshot.8d6abbe6.png";